"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORUM_NOTIFICATIONS_DISPLAY_NAME = exports.QMS_SYSTEM_USER_ID = void 0;
/** System bot в `ql`: уведомления форума («Сообщения 4PDA»). Никогда не вызывать `ql [0]`. */
exports.QMS_SYSTEM_USER_ID = 0;
/** Отображаемое имя, если сервер не прислал своё. */
exports.FORUM_NOTIFICATIONS_DISPLAY_NAME = 'Сообщения 4PDA';
